import React from 'react';
import footerImg from '../assets/images/footerImg.png';
import { Flex, Image, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { getSettings } from '../Network/home';
import { useQuery } from '@tanstack/react-query';
const FooterApp = ({ t }) => {
  const { data: dataFooter, isLoading } = useQuery({
    queryKey: ['getSettings'],
    queryFn: () => getSettings(),
  });
  return (
    <div className="footer-app">
      <div className="container">
        <div className="logo">
          <Image preview={false} src={footerImg} width={150} height={100} />
        </div>
        <div className="content">
          <p className="text-footer">
            {/* {t.descriptionFooter} */}
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 4 }} />
            ) : (
              dataFooter?.data?.footer
            )}
          </p>
          <div className="links-footer">
            <Flex
              gap={30}
              align="start"
              style={{
                flexDirection: 'column',
              }}
            >
              <Link to="/">{t.home}</Link>
              <Link to="/projects">{t.Projects}</Link>
            </Flex>
            <Flex
              gap={30}
              align="start"
              style={{
                flexDirection: 'column',
              }}
            >
              <Link to="/services">{t.Services}</Link>
              <Link to="/about">{t.AboutUs}</Link>
            </Flex>
          </div>
        </div>
        <div className="link-social">
          {/* <a href="">
            <FaFacebook />
          </a>
          <a href="">
            <FaInstagram />
          </a> */}
          <a
            // href="https://www.linkedin.com/company/mersestudio/"
            href={dataFooter?.data?.linkedin}
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterApp;
